import React from 'react';
import api from './../../../services/api';
//import { NavLink } from 'react-router-dom';
import { user_token } from '../../../services/Auth';

//import da API
import { professional } from './../../../services/api'
let apiProfessional = new professional();

var token = localStorage.getItem(user_token);
//var medico_id = localStorage.getItem("professional_id");

export default class FormsEdit extends React.Component {

    //PATCH LOGIC
    constructor() {
        super();
        this.state = {
            medical_note: "",

        };
        this.handleChange = this.handleChange.bind(this);
        //this.handleSubmit = this.handleSubmit.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });

    }

    handleSubmit = evt => {
        evt.preventDefault();

        const exam = {
            medical_note: this.state.medical_note,

        };

        //Print dos dados enviados
        console.log(exam);

        //ID está setada -> Necessário Correção
        apiProfessional.editExam(exam, this.props.exam_id, 'set')
            //api.patch(`/exam/${this.props.exam_id}`, exam, {headers: {'x-access-token': token, 'op':"set"} })
            .then(res => {
                console.log(res);
                console.log(res.data);
                alert("Observações alteradas com sucesso!");
            }).then(() => {
                this.setState({
                    medical_note: ''
                })
            })

    }

    render() {
        return (
            <>
                <br></br>
                <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
                    <h1 id="tittle-forms-cme">Formulário de edição de notas</h1>

                    <p id="RI-Title-Cadastro" >Editar Notas da Consulta</p>
                    <textarea value={this.state.medical_note} onChange={this.handleChange} name="medical_note" placeholder="Insira a observação da consulta: " id="RI-Cadastro" required />

                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <button onClick={() => this.handleSubmit} id="PS">Editar Notas da Consulta</button>
                    </div>
                </form>
            </>
        );
    }
}
